import React, {useEffect, useState} from 'react'
import {Grid, InputLabel, FormHelperText} from '@material-ui/core'
import _ from 'lodash'
import useReservedForFieldValuesReducer from '../../../state/reservation/reserved-for-field-values/reducer'
import {getReservedForFieldValues} from '../../../state/reservation/reserved-for-field-values/actions'
import './StepActionField.scss'
import Select from 'react-select'

export default function WMemoField({data, onChange, itemSelected, fieldId, fieldType, tabActive}) {
  const [search, setSearch] = useState('')
  const [optionList, setOptionList] = useState([])
  const newoptionList = []
  const [list, reservedForFieldValuesDispatch] = useReservedForFieldValuesReducer()
  const isTrue = itemSelected?.reserve_for?.field_id.includes(`${data.id}`)

  const getOptionList = userList => {
    if (userList) {
      if (!userList.isLoading && userList.data) {
        const newOptionList = userList.data.map(fv => ({
          value: fv.id,
          label: fv.name,
        }))
        return setOptionList(newOptionList)
      }
    }
  }

  useEffect(() => {
    getReservedForFieldValues(
      reservedForFieldValuesDispatch,
      [fieldId],
      fieldType,
      search
    ).then(res => getOptionList(res))
    // eslint-disable-next-line
  }, [fieldType, reservedForFieldValuesDispatch, search, fieldId])

  useEffect(() => {
    if (isTrue) {
      let selected = itemSelected?.reserve_for?.value_id
      onChange(null, data.key, selected)
    }
    // eslint-disable-next-line
  }, [])

  const onSetOption = (e, data_key) => {
    onChange(null, data_key, e?.value)
  }

  return (
    <Grid item xs={6} className="select-search-container">
      <InputLabel id="demo-mutiple-name-label">
        <small>{data.name}</small>
      </InputLabel>
      <Select
        classNamePrefix="select"
        className="select-search"
        isSearchable={true}
        isLoading={list.isLoading}
        labelId="demo-mutiple-name-label"
        id="demo-simple-select"
        placeholder={isTrue ? itemSelected?.reserve_for?.value : data.name}
        options={optionList}
        onChange={e => {
          onSetOption(e, data.key)
        }}
        onInputChange={e => setSearch(e)}
        isDisabled={isTrue ? true : false}
      />
      <FormHelperText className="ap-textfield">
        {(() => {
          if (
            (tabActive === 'upcoming' && data.is_required) ||
            (tabActive === 'ongoing' && data.is_required_return)
          ) {
            return 'required*'
          } else {
            return 'optional'
          }
        })()}
      </FormHelperText>
    </Grid>
  )
}
